var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 87,
    viewBox: "0 0 186 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 70.875L19.125 75.375L14.625 76.5L17.625 79.875L16.875 85.125L21.75 82.875L26.625 85.125L25.875 79.875L28.875 76.5L24.375 75.375L21.75 70.875Z",
    fill: "#E3E4E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 42.375L7.125 46.875L2.625 48L5.625 51.375L4.875 56.625L9.75 54.375L14.625 56.625L13.875 51.375L16.875 48L12.375 46.875L9.75 42.375Z",
    fill: "#E3E4E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 18.5781L9.01562 21.7656L5.82812 22.5625L7.95312 24.9531L7.42188 28.6719L10.875 27.0781L14.3281 28.6719L13.7969 24.9531L15.9219 22.5625L12.7344 21.7656L10.875 18.5781Z",
    fill: "#E3E4E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 1.09375L23.9688 3.71875L21.3438 4.37498L23.0938 6.34373L22.6562 9.40623L25.5 8.09373L28.3438 9.40623L27.9062 6.34373L29.6562 4.37498L27.0312 3.71875L25.5 1.09375Z",
    fill: "#E3E4E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5725 48.7H71.9265L72.3585 44.488H75.0045L76.0305 34.606H73.3305L73.7625 30.394H76.4625L77.3805 21.7H82.0785L81.1605 30.394H84.9945L85.9125 21.7H90.6105L89.6925 30.394H92.4465L92.0145 34.606H89.2605L88.2345 44.488H90.9885L90.5565 48.7H87.8025L86.6685 59.5H81.9705L83.1045 48.7H79.2705L78.1365 59.5H73.4385L74.5725 48.7ZM83.5365 44.488L84.5625 34.606H80.7285L79.7025 44.488H83.5365ZM103.846 30.664H97.6364V26.452C99.3284 26.452 100.678 26.308 101.686 26.02C102.73 25.732 103.558 25.264 104.17 24.616C104.782 23.932 105.322 22.96 105.79 21.7H109.786V59.5H103.846V30.664Z",
    fill: "#337BBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.25 70.875L166.875 75.375L171.375 76.5L168.375 79.875L169.125 85.125L164.25 82.875L159.375 85.125L160.125 79.875L157.125 76.5L161.625 75.375L164.25 70.875Z",
    fill: "#E3E4E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.25 42.375L178.875 46.875L183.375 48L180.375 51.375L181.125 56.625L176.25 54.375L171.375 56.625L172.125 51.375L169.125 48L173.625 46.875L176.25 42.375Z",
    fill: "#E3E4E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.125 18.5781L176.984 21.7656L180.172 22.5625L178.047 24.9531L178.578 28.6719L175.125 27.0781L171.672 28.6719L172.203 24.9531L170.078 22.5625L173.266 21.7656L175.125 18.5781Z",
    fill: "#E3E4E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 1.09375L162.031 3.71875L164.656 4.37498L162.906 6.34373L163.344 9.40623L160.5 8.09373L157.656 9.40623L158.094 6.34373L156.344 4.37498L158.969 3.71875L160.5 1.09375Z",
    fill: "#E3E4E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOne);
export default __webpack_public_path__ + "static/media/number-one.46383c78716aef9eefbeb102f3220472.svg";
export { ForwardRef as ReactComponent };